var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<form name=\"vm.detailForm\"><div flex=\"flex\" layout=\"row\"><div flex=\"80\" align-content=\"flex-start\" layout=\"column\"><div layout=\"row\"><div flex=\"48\" class=\"form-group\"><label for=\"fName\" class=\"control-label\">First Name</label><input ng-model=\"vm.docSvc.doc.firstName\" class=\"form-control\"/></div><div flex=\"48\" class=\"form-group\"><label for=\"lName\" class=\"control-label\">Last Name</label><input ng-model=\"vm.docSvc.doc.lastName\" class=\"form-control\"/></div><div flex=\"48\" class=\"form-group\"><label for=\"username\" class=\"control-label\">Username</label><input ng-model=\"vm.docSvc.doc.username\" class=\"form-control\"/></div></div></div></div></form>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/administration/users/tabs/topPanel.jade
// module id = 176
// module chunks = 0